// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__1oe5J","rowsWrapper":"style_rowsWrapper__1mUq4","rowWrapper":"style_rowWrapper__fB8Iw","edit_wrapper":"style_edit_wrapper__20h51"};